// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {CustomThemeProvider} from './ThemeContext';
import '@fontsource/inter/400.css';
import {installConsoleVerbosity} from './logging';
import i18n from './i18n';

installConsoleVerbosity();

// In production, catch unexpected global errors and hard-redirect to /error.
// (The ErrorBoundary already handles React render/lifecycle errors.)
if (process.env.NODE_ENV === 'production') {
    window.addEventListener('error', () => {
        // Avoid redirect loops if already on /error
        if (window.location.pathname !== '/error') {
            window.location.assign('/error');
        }
    });
    window.addEventListener('unhandledrejection', () => {
        if (window.location.pathname !== '/error') {
            window.location.assign('/error');
        }
    });
}

const root = ReactDOM.createRoot(document.getElementById('root'));

// Wait for i18next to initialize before rendering the app
i18n.on('initialized', () => {
    root.render(
        <React.StrictMode>
            <CustomThemeProvider>
                <App/>
            </CustomThemeProvider>
        </React.StrictMode>
    );
});

reportWebVitals();
